.edgeEnd {
  margin-right: -12px;
}
